export const SanctionsType = {
  name: "sanctions-type",
  component: "MainPanel",
  layout: "main-panel large padded align-center",
  mode: "visible",
  text: "foul.type", //TODO: is this correct?
  showOn: [{ state: "primary", value: "sanctions-type", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  children: [
    {
      name: "suspension-buttons",
      component: "ButtonPanel",
      layout: "button-group centered",
      mode: "visible",
      showOn: [true],
      children: [
        {
          name: "2min-suspension",
          component: "TypeButton",
          layout: "type-button",
          mode: "enable",
          text: "suspension.2min",
          showOn: [true],
          actionGroups: [
            {
              actions: [
                { action: "stopClock", value: "stop", type: "main" },
                { action: "saveData", value: "suspension", type: "eventType" },
                { action: "saveData", value: "twoMinutes", type: "subType" },
                {
                  action: "saveData",
                  value: [{ option: "possible", value: true }],
                  type: "options",
                },
                { action: "sendEvent", value: "new", type: "main" },
                {
                  action: "nextState",
                  value: "punishment-player",
                  type: "primary",
                },

                { action: "processInserts", value: "all", type: "inserts" },
              ],
              conditions: [],
            },
          ],
          startEvent: true,
          startPlay: true,
        },
        {
          name: "4min-suspension",
          component: "TypeButton",
          layout: "type-button",
          mode: "enable",
          text: "suspension.4min",
          showOn: [true],
          actionGroups: [
            {
              actions: [
                { action: "stopClock", value: "stop", type: "main" },
                { action: "saveData", value: "suspension", type: "eventType" },
                { action: "saveData", value: "fourMinutes", type: "subType" },
                {
                  action: "saveData",
                  value: [{ option: "possible", value: true }],
                  type: "options",
                },
                { action: "sendEvent", value: "new", type: "main" },
                {
                  action: "nextState",
                  value: "punishment-player",
                  type: "primary",
                },

                { action: "processInserts", value: "all", type: "inserts" },
              ],
              conditions: [],
            },
          ],
          startEvent: true,
          startPlay: true,
        },
      ],
    },
    {
      name: "card-buttons",
      component: "ButtonPanel",
      layout: "button-group centered",
      mode: "visible",
      showOn: [true],
      children: [
        {
          name: "yellow-card",
          component: "TypeButton",
          layout: "type-button yellowCard",
          mode: "enable",
          text: "yellowCard",
          showOn: [true],
          actionGroups: [
            {
              actions: [
                { action: "saveData", value: "yellowCard", type: "eventType" },
                { action: "copyEvent", value: "card", type: "to" },
                {
                  action: "saveData",
                  value: [{ option: "possible", value: true }],
                  type: "options",
                },
                { action: "sendEvent", value: "new", type: "main" },
                {
                  action: "nextState",
                  value: "punishment-player",
                  type: "primary",
                },

                { action: "processInserts", value: "all", type: "inserts" },
              ],
              conditions: [],
            },
          ],
          startEvent: true,
          startPlay: true,
        },
        {
          name: "red-card",
          component: "TypeButton",
          layout: "type-button redCard",
          mode: "enable",
          text: "redCard",
          showOn: [true],
          actionGroups: [
            {
              actions: [
                { action: "stopClock", value: "stop", type: "main" },
                { action: "saveData", value: "redCard", type: "eventType" },
                {
                  action: "saveData",
                  value: [{ option: "possible", value: true }],
                  type: "options",
                },
                { action: "sendEvent", value: "new", type: "main" },
                { action: "copyEvent", value: "card", type: "to" },
                { action: "newEvent", value: null, type: "main" },
                { action: "saveData", value: "suspension", type: "eventType" },
                { action: "saveData", value: "twoMinutes", type: "subType" },
                { action: "sendEvent", value: "new", type: "main" },
                { action: "copyEvent", value: "suspension", type: "to" },
                { action: "copyEvent", value: "card", type: "from" },
                {
                  action: "nextState",
                  value: "punishment-player",
                  type: "primary",
                },

                { action: "processInserts", value: "all", type: "inserts" },
              ],
              conditions: [],
            },
          ],
          startEvent: true,
          startPlay: true,
        },
        {
          name: "blue-card",
          component: "TypeButton",
          layout: "type-button blueCard",
          mode: "enable",
          text: "blueCard",
          showOn: [true],
          actionGroups: [
            {
              actions: [
                { action: "stopClock", value: "stop", type: "main" },
                { action: "saveData", value: "blueCard", type: "eventType" },
                { action: "sendEvent", value: "new", type: "main" },
                { action: "copyEvent", value: "card", type: "to" },

                { action: "newEvent", value: null, type: "main" },
                { action: "saveData", value: "suspension", type: "eventType" },
                { action: "saveData", value: "twoMinutes", type: "subType" },
                { action: "sendEvent", value: "new", type: "main" },
                { action: "copyEvent", value: "suspension", type: "to" },

                { action: "copyEvent", value: "card", type: "from" },
                {
                  action: "nextState",
                  value: "punishment-player",
                  type: "primary",
                },

                { action: "processInserts", value: "all", type: "inserts" },
              ],
              conditions: [],
            },
          ],
          startEvent: true,
          startPlay: true,
        },
      ],
    },
  ],
};
